"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var useWindowSize = function useWindowSize() {
  var theme = (0, _core.useTheme)();
  var isDesktop = (0, _core.useMediaQuery)(theme.breakpoints.up('sm'), {
    defaultMatches: true
  });
  var isUpLg = (0, _core.useMediaQuery)(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });
  return {
    isDesktop: isDesktop,
    isUpLg: isUpLg
  };
};

var _default = useWindowSize;
exports.default = _default;